import {
  ClientType,
  WithdrawalAccounts,
} from 'modules/onboarding/common/components';

import { isFinanceProject } from '../../../../config';
import { useOwnerWithdrawalAccounts } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerWithdrawalAccountsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
    files,
    onAddFiles,
    onRemoveFile,
  } = useOwnerWithdrawalAccounts();

  return (
    <WithdrawalAccounts
      canGoBack={canGoBack}
      clientType={isFinanceProject() ? ClientType.Client : undefined}
      countries={countries}
      countriesLoading={countriesLoading}
      files={files}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
